import { motion } from 'framer-motion'
import { FileText } from 'lucide-react'

interface Props {
  fileNames: string[]
}

function fileColor(name: string): string {
  const ext = name.split('.').pop()?.toLowerCase()
  if (ext === 'pdf') return 'text-amber-400'
  if (ext === 'step' || ext === 'stp') return 'text-emerald-400'
  return 'text-cyan-400'
}

export default function UserFileLine({ fileNames }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.15 }}
      className="flex items-center gap-2 py-1.5 pl-1"
    >
      {fileNames.map(name => (
        <span key={name} className="inline-flex items-center gap-1.5">
          <FileText className={`w-3.5 h-3.5 ${fileColor(name)}`} />
          <span className="font-mono text-xs text-slate-200">{name}</span>
        </span>
      ))}
    </motion.div>
  )
}
